import {Utils} from "./Utils";

export interface TimerConfig {
    container: HTMLElement;
}

type TimeType = {
    total: number;
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
}

type TimerMessageType = {
    message: string;
    days: string;
    hours: string;
    minutes: string;
    seconds: string;
}


export class Timer {
    public readonly elements: {
        container: HTMLElement;
    };

    constructor({container}: TimerConfig) {
        this.elements = {container};
        this.init();
    }

    get timestamp(): number {
        const timestamp = +this.elements.container.getAttribute(`data-timer`);
        if (!isNaN(timestamp)) return timestamp;
        throw new Error(`Time stamp is not a number`);
    }

    public getTime(): TimeType {
        if (this.elements.container) {
            const
                currentDate = Math.round(new Date().getTime() / 1000),
                time = this.timestamp - currentDate,
                seconds = Math.floor(time % 60),
                minutes = Math.floor((time / 60) % 60),
                hours = Math.floor((time / (60 * 60)) % 24),
                days = Math.floor(time / (60 * 60 * 24));

            return {
                'total': time,
                'days': days,
                'hours': hours,
                'minutes': minutes,
                'seconds': seconds
            };
        }
    }

    public timerData(): TimerMessageType {
        if (Utils.getLang() === `ru_ru`) {
            return {
                message: `Время вышло!`,
                days: `дней`,
                hours: `часов`,
                minutes: `мин`,
                seconds: `сек`
            }
        } else {
            return {
                message: `Time is up!`,
                days: `days`,
                hours: `hours`,
                minutes: `min`,
                seconds: `sec`
            }
        }
    }

    public timerTemplate(time: TimeType): string {
        let
            data = this.timerData(),
            dayTemplate = ``;

        if (time.days > 0) {
            dayTemplate = `
                <li class="timer__item">
                    <span class="timer__value">${('0' + time.days).slice(-2)}</span>
                    <span class="timer__name">${data.days}</span>
                </li>
            `;
        }

        return (`
            ${dayTemplate}
            <li class="timer__item">
                <span class="timer__value">${('0' + time.hours).slice(-2)}</span>
                <span class="timer__name">${data.hours}</span>
            </li>
            <li class="timer__item">
                <span class="timer__value">${('0' + time.minutes).slice(-2)}</span>
                <span class="timer__name">${data.minutes}</span>
            </li>
            <li class="timer__item">
                <span class="timer__value">${('0' + time.seconds).slice(-2)}</span>
                <span class="timer__name">${data.seconds}</span>
            </li>
        `);
    }

    public messageTemplate(): string {
        let data = this.timerData();

        return (`
            <p class="timer__message">
                ${data.message}
            </p>
        `);
    }

    protected init(): void {
        const {container} = this.elements;
        if (!container) return;

        let updateTimer = () => {
            let time = this.getTime();
            if (time.total <= 0) {
                clearInterval(timeinterval);
                container.innerHTML = this.messageTemplate();
            } else {
                container.innerHTML = this.timerTemplate(time);
            }
        };

        let timeinterval = setInterval(updateTimer, 1000);
    }
}